import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack, max, min } from '../../utils/index.js';
var rgb2hcg = function rgb2hcg() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _unpack = unpack(args, 'rgb'),
    _unpack2 = _slicedToArray(_unpack, 3),
    r = _unpack2[0],
    g = _unpack2[1],
    b = _unpack2[2];
  var minRgb = min(r, g, b);
  var maxRgb = max(r, g, b);
  var delta = maxRgb - minRgb;
  var c = delta * 100 / 255;
  var _g = minRgb / (255 - delta) * 100;
  var h;
  if (delta === 0) {
    h = Number.NaN;
  } else {
    if (r === maxRgb) h = (g - b) / delta;
    if (g === maxRgb) h = 2 + (b - r) / delta;
    if (b === maxRgb) h = 4 + (r - g) / delta;
    h *= 60;
    if (h < 0) h += 360;
  }
  return [h, c, _g];
};
export default rgb2hcg;